import { render } from "./TableListingInformation.vue?vue&type=template&id=6a85c2ef&scoped=true"
const script = {}

import "./TableListingInformation.vue?vue&type=style&index=0&id=6a85c2ef&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a85c2ef"]])

export default __exports__